import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df49e28e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-group"
}
const _hoisted_2 = {
  key: 0,
  class: "fa fa-bolt ms-2"
}
const _hoisted_3 = {
  key: 1,
  class: "input-group"
}
const _hoisted_4 = {
  type: "text",
  class: "form-control d-flex align-items-center flex-row",
  style: {"flex":"1 1 auto"}
}
const _hoisted_5 = { class: "type" }
const _hoisted_6 = { style: {"display":"inline-block","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"} }
const _hoisted_7 = {
  key: 0,
  class: "fa fa-bolt ms-2"
}
const _hoisted_8 = {
  key: 2,
  class: "input-group"
}
const _hoisted_9 = {
  type: "text",
  class: "form-control d-flex flex-row align-items-center",
  style: {"flex":"1 1 auto"}
}
const _hoisted_10 = {
  key: 0,
  class: "type"
}
const _hoisted_11 = {
  key: 1,
  style: {"display":"inline-block","font-family":"monospace","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_12 = { style: {"font-size":"70%","line-height":"normal"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_14 = {
  key: 0,
  class: "fa fa-bolt ms-2"
}
const _hoisted_15 = {
  key: 3,
  class: "input-group"
}
const _hoisted_16 = {
  type: "text",
  class: "form-control",
  style: {"flex":"1 1 auto"}
}
const _hoisted_17 = { class: "type" }
const _hoisted_18 = {
  key: 0,
  class: "fa fa-bolt ms-2"
}
const _hoisted_19 = {
  key: 4,
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_20 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Select field", -1))
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_30 = {
  key: 0,
  class: "tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-variable" }, "Select available variable:", -1))
const _hoisted_33 = { class: "form-control" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-variable" }, "Select XML variable:", -1))
const _hoisted_38 = {
  key: 2,
  class: "tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "contact-tab"
}
const _hoisted_39 = {
  key: 3,
  class: "tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "contact-tab"
}
const _hoisted_40 = { class: "modal-footer" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_value_selector_tree = _resolveComponent("value-selector-tree")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.currentval.type === 'value')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.currentval.value.indexOf('\n') === -1)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                class: "form-control",
                placeholder: "Value",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentval.value) = $event))
              }, null, 512)), [
                [_vModelText, _ctx.currentval.value]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 1,
                type: "text",
                class: "form-control",
                placeholder: "Value",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentval.value) = $event))
              }, null, 512)), [
                [_vModelText, _ctx.currentval.value]
              ]),
          _createElementVNode("span", {
            class: "input-group-text pointer-cursor",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editval = Object.assign({}, _ctx.currentval)))
          }, [
            (!_ctx.currentval || !_ctx.currentval.name)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.currentval.type === 'variable')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentval.type) + " : ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentval && _ctx.currentval.variable ? _ctx.currentval.variable : ''), 1)
            ]),
            _createElementVNode("span", {
              class: "input-group-text pointer-cursor",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editval = Object.assign({}, _ctx.currentval)))
            }, [
              (!_ctx.currentval || !_ctx.currentval.name)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.currentval.type === 'code')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (!_ctx.currentval || _ctx.currentval.code.indexOf('\n') !== -1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.currentval.type), 1))
                  : _createCommentVNode("", true),
                (_ctx.currentval && _ctx.currentval.code.indexOf('\n') === -1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.currentval && _ctx.currentval.code ? _ctx.currentval.code : ''), 1),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: "input-group-text pointer-cursor",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editval = Object.assign({}, _ctx.currentval)))
              }, [
                (!_ctx.currentval || !_ctx.currentval.name)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentval.type), 1)
              ]),
              _createElementVNode("span", {
                class: "input-group-text pointer-cursor",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editval = Object.assign({}, _ctx.currentval)))
              }, [
                (!_ctx.currentval || !_ctx.currentval.name)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                  : _createCommentVNode("", true)
              ])
            ])),
    (_ctx.editval !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editval = false))
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("ul", _hoisted_25, [
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      class: _normalizeClass({ 'nav-link': true, 'active': _ctx.editval.type === 'variable' }),
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.editval.type = 'variable'), ["stop","prevent"])),
                      href: "#home",
                      role: "tab",
                      "aria-controls": "home",
                      "aria-selected": "true"
                    }, "Variable", 2)
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _createElementVNode("a", {
                      class: _normalizeClass({ 'nav-link': true, 'active': _ctx.editval.type === 'value' }),
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.editval.type = 'value'), ["stop","prevent"])),
                      href: "#contact",
                      role: "tab",
                      "aria-controls": "contact",
                      "aria-selected": "false"
                    }, "Value", 2)
                  ]),
                  _createElementVNode("li", _hoisted_28, [
                    _createElementVNode("a", {
                      class: _normalizeClass({ 'nav-link': true, 'active': _ctx.editval.type === 'code' }),
                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.editval.type = 'code'), ["stop","prevent"])),
                      href: "#contact",
                      role: "tab",
                      "aria-controls": "contact",
                      "aria-selected": "false"
                    }, "Code", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.editval.type === 'variable')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_value_selector_tree, {
                              options: _ctx.getVarTreeOptions(),
                              modelValue: _ctx.editval.variable,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editval.variable) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]),
                        (_ctx.editval.variable && _ctx.editval.variable.meta && _ctx.editval.variable.meta.schema)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Select subfield"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editval.type === 'xpath')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select select-variable",
                            id: "select-variable",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editval.variable) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vars, (variable, idx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (variable.type === 'xml')
                                  ? (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(variable.name), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.editval.variable]
                          ])
                        ]),
                        (_ctx.xmlTree)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.xmlTree.component), _mergeProps({ key: 0 }, _ctx.xmlTree.props, {
                              onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectTreeNode($event)))
                            }), null, 16))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editval.type === 'value')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "4",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editval.value) = $event))
                        }, " ", 512), [
                          [_vModelText, _ctx.editval.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editval.type === 'code')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "4",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editval.code) = $event))
                        }, " ", 512), [
                          [_vModelText, _ctx.editval.code]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    "data-dismiss": "modal",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editval = false))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                  }, "OK")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}